import { Heading, Paragraph, Popover } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

export const KwpInfoPopOver = () => {
  const { t } = useTranslation();
  return (
    <Popover.TriggerContext>
      <Paragraph>
        <Popover.Trigger inline>{t('register.solar.form.popover.kwp.label')}</Popover.Trigger>
      </Paragraph>
      <Popover>
        <Heading level={5} data-size="2xs">
          {t('register.solar.form.popover.kwp.header')}
        </Heading>
        <Paragraph>{t('register.solar.form.popover.kwp.info')}</Paragraph>
        <Heading level={5} data-size="2xs">
          {t('register.solar.form.popover.kwp.example.header')}
        </Heading>
        <Paragraph>{t('register.solar.form.popover.kwp.example.info')}</Paragraph>
      </Popover>
    </Popover.TriggerContext>
  );
};
